/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { CustomerRequestBuilderRequestsMetadata, type CustomerRequestBuilder } from './customer/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /calls/{id}
 */
export interface CallsItemRequestBuilder extends BaseRequestBuilder<CallsItemRequestBuilder> {
    /**
     * The customer property
     */
    get customer(): CustomerRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const CallsItemRequestBuilderUriTemplate = "{+baseurl}/calls/{id}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const CallsItemRequestBuilderNavigationMetadata: Record<Exclude<keyof CallsItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    customer: {
        requestsMetadata: CustomerRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
